import { createFileRoute } from '@tanstack/react-router'
import DashboardPage from '@/components/pages/DashboardPage/DashboardPage'

export const Route = createFileRoute('/$workspaceName/$environment/home')({
  component: EnvironmentHomeRoute,
})

function EnvironmentHomeRoute() {
  return <DashboardPage />
}
